export default __webpack_public_path__ + "static/video-poster-a88515f96429164bf3916ee85d0806da.jpg";